import { ApiHandler, createHandlerChainRunner, createHandlerChainRunnerOptionalParameter, HasOnComplete } from "@insite/client-framework/HandlerCreator";
import { WarehouseCollectionModel, WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import { getWarehouse } from "@WhiteCap/Services/GetWarehouseService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<string, WarehouseModel> & HasOnComplete;

export const DispatchBeginWarehouseData: HandlerType = props => {
    props.dispatch({
        type: "Custom/Warehouse/BeginLoadWarehouse",
    });
};
export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getWarehouse(props.apiParameter);
    // console.log("props.apiResult", props.apiResult);
};
export const DispatchCompleteWarehouseData: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }
    props.dispatch({
        type: "Custom/Warehouse/CompletedLoadWarehouse",
        result: props.apiResult,
    });
};


export const chain = [
    DispatchBeginWarehouseData,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteWarehouseData,
    // DispatchCompleteWarehouseDatasession,
];

const loadWarehouse = createHandlerChainRunner(chain,"LoadWarehouse");
export default loadWarehouse;
